enum FLUX_UPDATEPASS_CONSTANTS {
    UPDATEPASS_BEGIN = "UPDATEPASS_BEGIN",
    UPDATEPASS_FAILED = "UPDATEPASS_FAILED",
    UPDATEPASS_SUCCESS = "UPDATEPASS_SUCCESS",
    UPDATEPASS_CLEAR = "UPDATEPASS_CLEAR",
}

export default FLUX_UPDATEPASS_CONSTANTS